import React from 'react';

import withModal from '../../../../../../components/global/modal/withModal';
import RosterIdentityLinkedIdentityContactInfo from '.';

export const ROSTER_IDENTITY_CONTACT_INFO_MODAL =
  'modals/ROSTER_IDENTITY_CONTACT_INFO_MODAL';

const RosterIdentityLinkedIdentityContactInfoModal = props => (
  <RosterIdentityLinkedIdentityContactInfo {...props} />
);

export default withModal(RosterIdentityLinkedIdentityContactInfoModal, {
  name: ROSTER_IDENTITY_CONTACT_INFO_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  overlayClassName: 'z-modal-max',
});
